// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Skeleton, Space, Text } from '@mantine/core';
import { IconPlugConnectedX } from '@tabler/icons';
import { FC } from 'react';
import { useMailOutboundConfigs } from '../../../Service/hooks/useMailOutboundConfigs';
import { MailOutBoundConfigDTO } from '../../../Types/MailT';
import { useImapStore } from '../../../Service/hooks/useImapStore';
import InboxIcon from '../../../Atoms/InboxIcon';
import NavigationLink from '../../../Atoms/Navigation/NavigationLink';
import DefaultFolder from './DefaultFolderNav';

const MailOutboundConfigNav: FC<{ closeNavBar: () => void }> = ({ closeNavBar }) => {
  const { loading, mailOutboundConfigs } = useMailOutboundConfigs(true);

  if (loading) {
    return <Skeleton width="100%" height={200} />;
  }

  return (
    <>
      {mailOutboundConfigs.map((cfg) => (
        <MailOutboundConfigDefaultFolderIMAP key={cfg.id} config={cfg} closeNavBar={closeNavBar} />
      ))}
    </>
  );
};

const MailOutboundConfigDefaultFolderIMAP: FC<{ config: MailOutBoundConfigDTO; closeNavBar: () => void }> = ({
  config,
  closeNavBar,
}) => {
  const { loadingFolder, defaultFolder } = useImapStore(config);
  const { email } = config;

  return (
    <>
      <Space h="md" />
      <NavigationLink defaultOpened compact label={<Text weight="bolder">{email}</Text>} icon={<InboxIcon size={20} />}>
        {loadingFolder && <Skeleton height={200} mx="sm" mb="xs" />}
        {defaultFolder && <DefaultFolder config={config} folder={defaultFolder} closeNavBar={closeNavBar} />}
        {!loadingFolder && defaultFolder === null && (
          <Group spacing="xs" mt="xs" pb="xs" noWrap>
            <IconPlugConnectedX size={16} color="#E65351" />
            <Text size="xs" color="red">
              Verbindung zum Postfach nicht moeglich.
            </Text>
          </Group>
        )}
      </NavigationLink>
    </>
  );
};

export default MailOutboundConfigNav;
